import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  imports: [RouterLink],
  selector: 'iw-logo',
  template: `
    <a class="logo" routerLink="/">
      <svg>
        <use
          [attr.xlink:href]="'assets/icons.svg#logo'"
          [attr.href]="'assets/icons.svg#logo'"
        ></use>
      </svg>
    </a>
  `,
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {}
